export default __webpack_public_path__ + "static/APP_3_3_2-b60ee5184215991400b20b9eb59f9113.png";